var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStreamIcon = function SvgStreamIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1,
    strokeWidth: 0.322,
    d: "M44.565 6.97c-1.202 5.67 3.564 17.117 15.238 24.75 9.44 8.072-17.724 25.59-33.118 38.637C5.12 88.645 5.003 106.29 21.625 129.06c.447.593 1.133.804 1.962.784l97.895.186c.811-.013 1.051-.837 1.04-1.731-.181-13.644-62.486-28.156-49.718-61.068 5.43-12.127 23.449-28.597 13.49-39.524-6.276-5.742-25.478-12.521-32.82-22.342-2.75-3.731-7.384-5.078-8.909 1.604z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStreamIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stream-icon.1f8291d6a6027b5e0de2097d56cf3792.svg";